import { useState } from "react";
import type { FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { hotTags } from "@/mocks/kuaibao";

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/kuaibao?q=${encodeURIComponent(q)}` : "/kuaibao");
  };

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20artistic%20editorial%20background%20with%20warm%20coral%20amber%20and%20deep%20maroon%20gradient%20shapes%2C%20soft%20paper%20grain%20texture%2C%20bold%20flowing%20forms%20like%20stage%20light%20beams%2C%20modern%20magazine%20cover%20art%2C%20high%20detail&width=1600&height=900&seq=gua-hero-main-01&orientation=landscape"
        alt="51.cg今日吃瓜单品牌首屏背景"
        title="51.cg今日吃瓜单 - 吃瓜快报一分钟刷完全部热点"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-950/60 to-foreground-950/75"></div>

      <div className="relative w-full px-4 md:px-8 py-24 md:py-28">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/12 border border-background-50/25 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-live-dot"></span>
            <span className="font-label text-xs md:text-sm text-background-100 tracking-wide">
              吃瓜快报 · 速览模式已开启 · 今日已更新 38 条
            </span>
          </div>

          <h1 className="font-heading font-black text-background-50 leading-tight mb-5">
            <span className="block text-2xl md:text-3xl text-background-200 font-semibold tracking-wide mb-2">
              51.cg 今日吃瓜单
            </span>
            <span className="block text-4xl md:text-6xl">一分钟刷完全部热点</span>
          </h1>

          <p className="font-label text-sm md:text-base text-background-200 leading-relaxed max-w-2xl mx-auto mb-8">
            不用逐个平台翻找。今日瓜单与快报总览一站集齐，按热度排好序、压成一句话，
            让你在通勤路上、排队间隙就能快速跟上吃瓜节奏，省时省力不迷路。
          </p>

          <form
            onSubmit={handleSearch}
            className="flex flex-col sm:flex-row items-stretch gap-2 max-w-xl mx-auto mb-10"
          >
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-500 text-base leading-none"></i>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索快报标题、话题或关键词"
                className="w-full h-12 pl-10 pr-4 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 font-label text-sm outline-none focus:ring-2 focus:ring-accent-400"
              />
            </div>
            <button
              type="submit"
              className="h-12 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-label text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              搜一下
            </button>
          </form>

          <div className="grid grid-cols-3 gap-3 md:gap-6 max-w-2xl mx-auto">
            {[
              { value: "38", label: "今日新增快报" },
              { value: "8", label: "热门内容分类" },
              { value: "1 分钟", label: "平均速览耗时" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading font-bold text-xl md:text-3xl text-background-50 mb-1">
                  {stat.value}
                </div>
                <div className="font-label text-[11px] md:text-xs text-background-300 tracking-wide">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 border-t border-background-50/15 bg-foreground-950/45 backdrop-blur-sm overflow-hidden">
        <div className="flex w-max animate-marquee py-3">
          {[...hotTags, ...hotTags].map((tag, i) => (
            <span
              key={`${tag}-${i}`}
              className="flex items-center gap-2 px-5 font-label text-xs md:text-sm text-background-200 whitespace-nowrap"
            >
              <i className="ri-flashlight-line text-accent-400 leading-none"></i>
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}